import React from 'react';
import { MdOutlineContentCopy } from 'react-icons/md';
import {
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Flex,
  Box,
  Icon,
} from '@chakra-ui/react';
import { Tag } from 'components';
import { useCustomToast } from 'hooks';

interface FgtPwModalProps {
  isOpen: boolean;
  onClose: () => void;
  modalInfo: { name: string; value: string }[] | null;
}

export const DetailsModal = ({
  isOpen,
  onClose,
  modalInfo,
}: FgtPwModalProps) => {
  const { handleToast } = useCustomToast();
  const isTag = (name: string) => {
    switch (name) {
      case 'Status':
        return true;
      case 'Ação':
        return true;
      case 'Seção acessada':
        return true;
      default:
        return false;
    }
  };

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    handleToast({
      step: 5,
      action: 'Texto copiado com sucesso!',
    });
  };

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minW={{ base: '80%', md: '716px' }}
        py="24px"
        px="18px"
        bg="white"
      >
        <ModalHeader
          p="0px"
          px="8px"
          fontSize="xl"
          fontWeight={800}
          color="black"
          alignSelf="start"
          mb="15px"
        >
          Detalhes
        </ModalHeader>
        <ModalCloseButton mt="16px" mr="8px" color="black" />

        <ModalBody py="0px " px="8px" textAlign="start">
          {modalInfo?.map((detail, index) => (
            <Flex w="100%" key={index}>
              <Box
                p="8px 16px"
                borderTopLeftRadius={index === 0 ? '8px' : '0px'}
                borderBottomLeftRadius={
                  index === modalInfo.length - 1 ? '8px' : '0px'
                }
                border="1px solid"
                borderColor="#D9D9D9"
                w="50%"
                bg="grey.400"
              >
                <Text color="text.100">{detail.name}</Text>
              </Box>
              <Flex
                justifyContent="space-between"
                alignItems="center"
                p={
                  isTag(detail.name) ? '8px 16px 8px 12px' : '8px 16px 8px 16px'
                }
                borderTopRightRadius={index === 0 ? '8px' : '0px'}
                borderBottomRightRadius={
                  index === modalInfo.length - 1 ? '8px' : '0px'
                }
                border="1px solid"
                borderColor="#D9D9D9"
                w="50%"
              >
                {isTag(detail.name) ? (
                  <Tag fontWeight="500" fontSize="14px" label={detail.value} />
                ) : (
                  <Text mr="16px" isTruncated color="text.100">
                    {detail.value}
                  </Text>
                )}
                {detail.name.toLowerCase().includes('id') && (
                  <Icon
                    cursor="pointer"
                    onClick={() => handleCopy(detail.value)}
                    color="black"
                    as={MdOutlineContentCopy}
                  />
                )}
              </Flex>
            </Flex>
          ))}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
